import type { RouteRecordRaw } from 'vue-router';

export const supportRoutes: Array<RouteRecordRaw> = [
  {
    path: '/support',
    name: 'support',
    redirect: '/support/request',
  },
  {
    path: '/support/category',
    name: 'supportCategory',
    redirect: '/support/category/list',
    component: () => import('pages/micros/support/category/SupportCategory.vue'),
    meta: {
      title: 'Support Categories, by group - request, blog, chat, comment, message',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportCategoryList',
        component: () => import('pages/micros/support/category/CategoryList.vue'),
        meta: {
          title: 'Support Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportCategoryDetail',
        component: () => import('pages/micros/support/category/CategoryDetail.vue'),
        meta: {
          title: 'Support Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportCategoryNew',
        component: () => import('pages/micros/support/category/CategoryNew.vue'),
        meta: {
          title: 'New Support Category',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'supportCategoryExplorer',
        component: () => import('pages/micros/support/category/CategoryExplorer.vue'),
        meta: {
          title: 'Categories Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/room',
    name: 'supportRoom',
    redirect: '/support/room/list',
    component: () => import('pages/micros/support/room/SupportRoom.vue'),
    meta: {
      title: 'Rooms [Support Groups] by categories - Public, Private, Message, Request, Blog, Chat',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportRoomList',
        component: () => import('pages/micros/support/room/RoomList.vue'),
        meta: {
          title: 'Rooms [Support Groups] List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportRoomDetail',
        component: () => import('pages/micros/support/room/RoomDetail.vue'),
        meta: {
          title: 'Room [Support Group] Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportRoomNew',
        component: () => import('pages/micros/support/room/RoomNew.vue'),
        meta: {
          title: 'New Room [Support Group]',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/room/member',
    name: 'supportRoomMember',
    redirect: '/support/room/member/list',
    component: () => import('pages/micros/support/roomMember/SupportRoomMember.vue'),
    meta: {
      title: 'Room Memberships - for private rooms',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportRoomMemberList',
        component: () => import('pages/micros/support/roomMember/RoomMemberList.vue'),
        meta: {
          title: 'Room Memberships List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportRoomMemberDetail',
        component: () => import('pages/micros/support/roomMember/RoomMemberDetail.vue'),
        meta: {
          title: 'Room Membership Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportRoomMemberNew',
        component: () => import('pages/micros/support/roomMember/RoomMemberNew.vue'),
        meta: {
          title: 'New Room Membership',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/blog',
    name: 'supportBlog',
    redirect: '/support/blog/list',
    component: () => import('pages/micros/support/blog/SupportBlog.vue'),
    meta: {
      title: 'Blogs - general, news, product etc.',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportBlogList',
        component: () => import('pages/micros/support/blog/BlogList.vue'),
        meta: {
          title: 'Blogs List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportBlogDetail',
        component: () => import('pages/micros/support/blog/BlogDetail.vue'),
        meta: {
          title: 'Blog Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportBlogNew',
        component: () => import('pages/micros/support/blog/BlogNew.vue'),
        meta: {
          title: 'New Blog',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'supportBlogExplorer',
        component: () => import('pages/micros/support/blog/BlogExplorer.vue'),
        meta: {
          title: 'Blogs Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/chat',
    name: 'supportChat',
    redirect: '/support/chat/list',
    component: () => import('pages/micros/support/chat/SupportChat.vue'),
    meta: {
      title: 'Chats - P2P | P2Group or P2Room real-time/off-line conversations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportChatList',
        component: () => import('pages/micros/support/chat/SioChats.vue'),
        meta: {
          title: 'Chats List - P2P Chats',
          requiresAuth: true,
        },
      },
      {
        path: 'room/chats',
        name: 'supportRoomChats',
        component: () => import('pages/micros/support/chat/SioRooms.vue'),
        meta: {
          title: 'Room Chats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportChatDetail',
        component: () => import('pages/micros/support/chat/SioChatDetail.vue'),
        meta: {
          title: 'Chat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportChatNew',
        component: () => import('pages/micros/support/chat/ChatNew.vue'),
        meta: {
          title: 'New Chat',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'supportChatExplorer',
        component: () => import('pages/micros/support/chat/ChatExplorer.vue'),
        meta: {
          title: 'Chats Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'supportChatStatusList',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusList.vue'),
        meta: {
          title: 'Chat Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'supportChatStatusDetail',
        component: () => import('pages/micros/support/chatStatus/SioChatStatusDetail.vue'),
        meta: {
          title: 'ChatStatus Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'supportChatStatusNew',
        component: () => import('pages/micros/support/chatStatus/ChatStatusNew.vue'),
        meta: {
          title: 'New Chat Status',
          requiresAuth: true,
        },
      },
      {
        path: 'access/list',
        name: 'supportChatAccessList',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessList.vue'),
        meta: {
          title: 'Chat Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'access/detail/:itemId?',
        name: 'supportChatAccessDetail',
        component: () => import('pages/micros/support/chatAccess/SioChatAccessDetail.vue'),
        meta: {
          title: 'Chat Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'access/new',
        name: 'supportChatAccessNew',
        component: () => import('pages/micros/support/chatAccess/ChatAccessNew.vue'),
        meta: {
          title: 'New Chat Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/chats',
    name: 'supportChats',
    redirect: '/support/chat/list',
    component: () => import('pages/micros/support/chat/SioChats.vue'),
    meta: {
      title: 'Chats [P2P | User]',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/support/p2p/chat',
    name: 'supportP2PChat',
    component: () => import('pages/micros/support/chat/P2PChat.vue'),
    meta: {
      title: 'P2P Chat [Registered user and/or Guest]',
      requiresAuth: false,
    },
  },
  {
    path: '/support/rooms',
    name: 'supportRooms',
    component: () => import('pages/micros/support/chat/SioRooms.vue'),
    meta: {
      title: 'Chat Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/support/join/room',
    name: 'supportJoinRoom',
    component: () => import('pages/micros/support/chat/SioJoinRoom.vue'),
    meta: {
      title: 'Join Rooms',
      requiresAuth: true,
    },
  },
  {
    path: '/support/message',
    name: 'supportMessage',
    redirect: '/support/message/list',
    component: () => import('pages/micros/support/message/SupportMessage.vue'),
    meta: {
      title: 'Messages - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportMessageList',
        component: () => import('pages/micros/support/message/MessageExplorerList.vue'),
        meta: {
          title: 'Messages List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:taskType?',
        name: 'supportMessageDetail',
        component: () => import('pages/micros/support/message/MessageDetail.vue'),
        meta: {
          title: 'Message Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportMessageNew',
        component: () => import('pages/micros/support/message/MessageNew.vue'),
        meta: {
          title: 'New Message',
          requiresAuth: true,
        },
      },
      {
        path: 'status/list',
        name: 'supportMessageStatusList',
        component: () => import('pages/micros/support/message/MessageStatusList.vue'),
        meta: {
          title: 'Message Statuses List',
          requiresAuth: true,
        },
      },
      {
        path: 'status/detail/:itemId?',
        name: 'supportMessageStatusDetail',
        component: () => import('pages/micros/support/message/MessageStatusDetail.vue'),
        meta: {
          title: 'Message Status Details',
          requiresAuth: true,
        },
      },
      {
        path: 'status/new',
        name: 'supportMessageStatusNew',
        component: () => import('pages/micros/support/message/MessageStatusNew.vue'),
        meta: {
          title: 'New Message Status',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/request',
    name: 'supportRequest',
    redirect: '/support/request/list',
    component: () => import('pages/micros/support/request/SupportRequest.vue'),
    meta: {
      title: 'Requests - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportRequestList',
        component: () => import('pages/micros/support/request/RequestList.vue'),
        meta: {
          title: 'Requests List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportRequestDetail',
        component: () => import('pages/micros/support/request/RequestDetail.vue'),
        meta: {
          title: 'Request Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportRequestNew',
        component: () => import('pages/micros/support/request/RequestNew.vue'),
        meta: {
          title: 'New Request',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/support/comment',
    name: 'supportComment',
    redirect: '/support/comment/list',
    component: () => import('pages/micros/support/comment/SupportComment.vue'),
    meta: {
      title: 'Support Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportCommentList',
        component: () => import('pages/micros/support/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportCommentDetail',
        component: () => import('pages/micros/support/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportCommentNew',
        component: () => import('pages/micros/support/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'supportCommentStatList',
        component: () => import('pages/micros/support/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'supportCommentStatDetail',
        component: () => import('pages/micros/support/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'supportCommentStatNew',
        component: () => import('pages/micros/support/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/rate',
    name: 'supportRate',
    redirect: '/support/rate/list',
    component: () => import('pages/micros/support/rate/SupportRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportRateList',
        component: () => import('pages/micros/support/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportRateDetail',
        component: () => import('pages/micros/support/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportRateNew',
        component: () => import('pages/micros/support/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/support/rating',
    name: 'supportRating',
    redirect: '/support/rating/list',
    component: () => import('pages/micros/support/rating/SupportRating.vue'),
    meta: {
      title: 'Ratings - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'supportRatingList',
        component: () => import('pages/micros/support/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'supportRatingDetail',
        component: () => import('pages/micros/support/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'supportRatingNew',
        component: () => import('pages/micros/support/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
];
